import React from 'react';
import Icon from './Icon';
var links = {};
var scripts = {};
export default function icon(url) {
  var fontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'iconfont';
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon';

  if (typeof url !== 'string') {
    console.error("Shineout Icon url must be a string, but get ".concat(url));
    return null;
  }

  var ext = url.substr(url.lastIndexOf('.') + 1);

  if (ext === 'css' && !links[url]) {
    links[url] = true;
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }

  if (ext === 'js' && !scripts[url]) {
    var script = document.createElement('script');
    scripts[url] = script;
    script.setAttribute('src', url);
    document.body.appendChild(script);
  }

  var wrapperIcon = function wrapperIcon(props) {
    return (
      /*#__PURE__*/
      React.createElement(Icon, Object.assign({
        ext: ext,
        fontFamily: fontFamily,
        prefix: prefix
      }, props))
    );
  };

  wrapperIcon.isShineoutIcon = true;
  return wrapperIcon;
}